// Co-located GraphQL operations for the console screens. Codegen scans this file
// and emits typed document nodes into src/gql/.
//
// Re-run `npm run codegen` whenever a query is added or changed.

import { graphql } from "@/gql";

export const TenantAssetsQuery = graphql(/* GraphQL */ `
  query TenantAssets {
    tenantAssets {
      id
      tenantId
      name
      locationState
      latitude
      longitude
      capacityMwh
      powerRatingMw
      socMinPct
      socMaxPct
      cRate
      roundTripEfficiencyPct
      bmsHost
      bmsPort
      bmsUnitId
      pollIntervalSeconds
    }
  }
`);

export const LatestRtmPricesQuery = graphql(/* GraphQL */ `
  query LatestRtmPrices($blocks: Int) {
    latestRtmPrices(blocks: $blocks) {
      time
      blockNumber
      mcpInrPerMwh
      mcvMw
      deliveryDate
    }
  }
`);

export const DamForecastStatusQuery = graphql(/* GraphQL */ `
  query DamForecastStatus {
    damForecastStatus {
      ready
      deliveryDate
      modelVersion
      generatedAt
    }
  }
`);

export const BmsStateQuery = graphql(/* GraphQL */ `
  query BmsState($assetId: ID!) {
    bmsState(assetId: $assetId) {
      assetId
      socPct
      sohPct
      chargePowerKw
      dischargePowerKw
      availableEnergyKwh
      temperatureMinC
      temperatureMaxC
      temperatureAvgC
      operationalMode
      updatedAt
    }
  }
`);

export const RtmForecastQuery = graphql(/* GraphQL */ `
  query RtmForecast($assetId: ID!) {
    rtmForecast(assetId: $assetId) {
      assetId
      generatedAt
      modelVersion
      predictions {
        blockNumber
        deliveryTime
        mcpForecastInrPerMwh
        confidenceInterval80 {
          lower
          upper
        }
        confidenceInterval95 {
          lower
          upper
        }
      }
    }
  }
`);

export const DamForecastQuery = graphql(/* GraphQL */ `
  query DamForecast($assetId: ID!, $deliveryDate: String) {
    damForecast(assetId: $assetId, deliveryDate: $deliveryDate) {
      assetId
      deliveryDate
      generatedAt
      modelVersion
      predictions {
        blockNumber
        deliveryTime
        mcpForecastInrPerMwh
        confidenceInterval80 {
          lower
          upper
        }
        confidenceInterval95 {
          lower
          upper
        }
      }
    }
  }
`);

export const AlertsActiveQuery = graphql(/* GraphQL */ `
  query AlertsActive($severity: String) {
    alertsActive(severity: $severity) {
      id
      tenantId
      ruleId
      firedAt
      status
      severity
      metric
      value
      assetId
      ackedAt
      resolvedAt
    }
  }
`);
